module.exports = __webpack_public_path__ + "img/fabry.21153021.png";